var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDimensions2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "",
    strokeWidth: "0.5px",
    d: "M20 4h-2V3h2zM9 22h3v-1H9zm-4 0h2v-1H5zM9 9h2V8H9zM5 9h2V8H5zm18 12h-1v1h2v-2h-1zM2 12H1v2h1zm20-8h1v1h1V3h-2zM1 18h1v-2H1zM14 8h-1v1h2V7h-1zm9 1h1V7h-1zm-8-5h1V3h-2v2h1zM1 10h1V9h1V8H1zm1 10H1v2h2v-1H2zm12 2h2v-1h-2zm9-9h1v-2h-1zm-5 9h2v-1h-2zm5-4h1v-3h-1zm-5-3H7v-2.19L3.942 15.5 7 18.19V16h11v2.19l3.058-2.69L18 12.81z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimensions2);
export default __webpack_public_path__ + "static/media/dimensions-2.b793ae9c0bec8330e4c57b7a824212e8.svg";
export { ForwardRef as ReactComponent };